import React from 'react';
import OwlCarousel from 'react-owl-carousel3';

const options = {
    loop: true,
    autoplay: true,
    nav: false,
    mouseDrag: true,
    autoplayHoverPause: true,
    responsiveClass: true,
    dots: true,
    navText: [
    "<i class='icofont-double-left'></i>",
    "<i class='icofont-double-right'></i>"
    ],
    responsive:{
        0:{
            items:1,
        },
        768:{
            items:2,
        },
        1200:{
            items:2,
        }
    }
}
 
class Feedback extends React.Component {
    render(){
        return (
            <section className="feedback-area ptb-100">
                <div className="container">
                    <div className="section-title">
                        <span>Testimonials</span>
                        <h3>What users say about us</h3>
                        <p>We enjoy providing users with tools that make planning events a bit easier, more enyoyable, and encourages people to Pitch In.</p>
                    </div>

                    <div className="row">
                        <OwlCarousel 
                            className="repair-feedback-slides owl-carousel owl-theme"
                            {...options}
                        >
                            <div className="col-lg-12 col-md-12">
                                <div className="single-repair-feedback">
                                    <div className="client-info">
                                    {/*
                                        <img src={require("../../assets/img/client-avatar1.jpg")} alt="" />
                                    */}
                                        <h3>Chrissy Eagan</h3>
                                        <span>Dietitian for Major NC Hospital</span>
                                    </div>

                                    <p>
                                        "This app was simple to use. I found the 'Helping Hands List' to be a nice feature.
                                        I was able to get a few volunteers to help out, which made a big difference.
                                        My event turned out better than originally planned.
                                    </p>

                                    <ul>
                                        <li><i className="icofont-star"></i></li>
                                        <li><i className="icofont-star"></i></li>
                                        <li><i className="icofont-star"></i></li>
                                        <li><i className="icofont-star"></i></li>
                                        <li><i className="icofont-star"></i></li>
                                    </ul>

                                    <i className="icofont-quote-left"></i>
                                </div>
                            </div>

                            <div className="col-lg-12 col-md-12">
                                <div className="single-repair-feedback">
                                    <div className="client-info">
                                       {/*
                                        <img src={require("../../assets/img/client-avatar2.jpg")} alt="" />
                                       */}
                                        <h3>Michael Ruiz</h3>
                                        <span>Project Champion for Data Analytics Firm</span>
                                    </div>

                                    <p>
                                    "This app was perfect for organizing a Company Picnic. 
                                     Good way to get people to Pitch In.  Saved me alot of 
                                     time by not having to do everything myself. Very helpful. Thanks"
                                    </p>

                                    <ul>
                                        <li><i className="icofont-star"></i></li>
                                        <li><i className="icofont-star"></i></li>
                                        <li><i className="icofont-star"></i></li>
                                        <li><i className="icofont-star"></i></li>
                                        <li><i className="icofont-star"></i></li>
                                    </ul>

                                    <i className="icofont-quote-left"></i>
                                </div>
                            </div>

                            {/*
                            <div className="col-lg-12 col-md-12">
                                <div className="single-repair-feedback">
                                    <div className="client-info">
                                        <img src={require("../../assets/img/client-avatar3.jpg")} alt="" />

                                        <h3>Michel Jonson</h3>
                                        <span>CEO at Renovation PVT. Ltd.</span>
                                    </div>

                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>

                                    <ul>
                                        <li><i className="icofont-star"></i></li>
                                        <li><i className="icofont-star"></i></li>
                                        <li><i className="icofont-star"></i></li>
                                        <li><i className="icofont-star"></i></li>
                                        <li><i className="icofont-star"></i></li>
                                    </ul>

                                    <i className="icofont-quote-left"></i>
                                </div>
                            </div>
                            */}
                        </OwlCarousel>
                    </div>
                </div>

                <div className="map-box"><img src={require("../../assets/img/map.png")} alt="" /></div>
            </section>
        );
    }
}
 
export default Feedback;


// WEBPACK FOOTER //
// ./src/components/versionSeven/Feedback.js